import React, { useState } from "react";
import _cloneDeep from "lodash.clonedeep";
import CustomQuestionModal from "./CustomQuestionModal";
import ConfirmationModal from "../../../shared/ConfirmationModal";

export default function EventCustomQuestions({
  event,
  onChange,
  submitAttempted,
  systemLists,
}) {
  const { adminRegistrationQuestions: registrationQuestions } = event;
  const { customQuestionResponseTypes } = systemLists;

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);

  const onAddQuestion = () => {
    setCurrentQuestionIndex(null);
    setShowAddEditModal(true);
  };

  const onDeleteQuestion = (questionIndex) => {
    setCurrentQuestionIndex(questionIndex);
    setShowDeleteConfirmationModal(true);
  };

  const onUpdateQuestion = (questionIndex) => {
    setCurrentQuestionIndex(questionIndex);
    setShowAddEditModal(true);
  };

  const addQuestion = (newQuestion) => {
    const newRegistrationQuestions = [
      ...registrationQuestions,
      { ...newQuestion },
    ];
    onChange("adminRegistrationQuestions", newRegistrationQuestions);

    setCurrentQuestionIndex(null);
    setShowAddEditModal(false);
  };

  const deleteQuestion = () => {
    const updatedRegistrationQuestions = _cloneDeep(registrationQuestions);

    // deactivate question if already saved to the db
    if (updatedRegistrationQuestions[currentQuestionIndex].id) {
      updatedRegistrationQuestions[currentQuestionIndex].isActive = false;
    }
    // otherwise remove the question
    else {
      updatedRegistrationQuestions.splice(currentQuestionIndex, 1);
    }

    onChange("adminRegistrationQuestions", updatedRegistrationQuestions);

    setCurrentQuestionIndex(null);
    setShowDeleteConfirmationModal(false);
  };

  const updateQuestion = (updatedQuestion) => {
    const updatedRegistrationQuestions = [...registrationQuestions];
    updatedRegistrationQuestions[currentQuestionIndex] = updatedQuestion;
    onChange("adminRegistrationQuestions", updatedRegistrationQuestions);

    setCurrentQuestionIndex(null);
    setShowAddEditModal(false);
  };

  // filter out inactive questions in the UI, maintain index for updates
  const activeRegistrationQuestions = registrationQuestions
    .map((q, index) => ({ ...q, index }))
    .filter((q) => q.isActive);

  return (
    <>
      <div className="program-settings-page-section">
        <p className="program-settings-page-title xxl-text fw-500">
          Custom Questions
        </p>
      </div>

      <div className="program-settings-page-section">
        <p className="accent-text-dark mb-16">
          Add any additional questions you feel necessary for students to answer
          when registering.
        </p>

        <div className="flex mb-16">
          <button
            className="custom-btn btn btn-accent btn-small uppercase-text fw-400 ml-16"
            onClick={onAddQuestion}
          >
            Add
          </button>
        </div>

        <div className="custom-questions-grid">
          <div className="custom-questions-grid-header">
            <p>Type</p>
            <p>Mandatory</p>
            <p>Text</p>
            <p />
          </div>

          {!!activeRegistrationQuestions.length ? (
            activeRegistrationQuestions.map((question) => (
              <div className="custom-questions-grid-row" key={question.index}>
                <p>{question.responseType}</p>
                <p>{question.isMandatory ? "Yes" : "No"}</p>
                <p style={{ textOverflow: "ellipsis" }}>
                  {question.questionText}
                </p>
                <p className="text-right">
                  <i
                    className="material-icons large-text link-text-secondary"
                    onClick={() => onUpdateQuestion(question.index)}
                  >
                    edit
                  </i>
                  <i
                    className="material-icons large-text ml-8 link-text-secondary"
                    onClick={() => onDeleteQuestion(question.index)}
                  >
                    delete
                  </i>
                </p>
              </div>
            ))
          ) : (
            <span>No custom questions</span>
          )}
        </div>
      </div>

      {showAddEditModal && (
        <CustomQuestionModal
          close={() => setShowAddEditModal(false)}
          save={currentQuestionIndex === null ? addQuestion : updateQuestion}
          questionToEdit={
            currentQuestionIndex != null
              ? registrationQuestions[currentQuestionIndex]
              : null
          }
          customQuestionResponseTypes={customQuestionResponseTypes}
          submitAttempted={submitAttempted}
        />
      )}

      {showDeleteConfirmationModal && (
        <ConfirmationModal
          cancel={() => setShowDeleteConfirmationModal(false)}
          confirm={deleteQuestion}
          message="Are you sure you want to delete this custom question?"
          show={true}
        />
      )}
    </>
  );
}
